import { render } from "./BiggerLoader.vue?vue&type=template&id=61717c9e"
import script from "./BiggerLoader.vue?vue&type=script&lang=js"
export * from "./BiggerLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__